<template>
  <FormBuilder
    :form="formBuilderForm"
    :config="config"
    @update:model-value="applyNewModel"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'

import {
  EGATE_CONFIG_DEFAULT,
  eGateConfig,
} from '@/apps/brelag/common/models/eGateConfig'
import FormBuilder from '@/components/common/forms/FormBuilder.vue'

const model = defineModel<typeof EGATE_CONFIG_DEFAULT>()
const formBuilderForm = ref({})

const config = {
  ...eGateConfig,
  model: JSON.parse(JSON.stringify(EGATE_CONFIG_DEFAULT)),
}

const applyNewModel = (newModel) => {
  model.value = newModel.value
}
</script>
